import script from "./QTLiteBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteBody.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteBody.vue?vue&type=style&index=0&id=bd86a506&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd86a506"]])

export default __exports__